import React from 'react';
import './Typography.css';

export type TypographyVariant = 
    | 'h1'
    | 'h2'
    | 'h3'
    | 'body-bold'
    | 'body'
    | 'body-small-bold'
    | 'body-small';   

interface TypographyProps {
    variant: TypographyVariant;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const Typography: React.FC<TypographyProps> = ({
    variant,
    children,
    className,
    style,
  }) => {
    let Component: React.ElementType = 'p';
    let variantClass = '';
  
    switch (variant) {
      case 'h1':
        Component = 'h1';
        variantClass = 'typography-h1';
        break;
      case 'h2':
        Component = 'h2';
        variantClass = 'typography-h2';
        break;
      case 'h3':
        Component = 'h3';
        variantClass = 'typography-h3';
        break;
      case 'body-bold':
        Component = 'p';
        variantClass = 'typography-body-bold';
        break;
      case 'body':
        Component = 'p';
        variantClass = 'typography-body';
        break;
      case 'body-small-bold':
        Component = 'p';
        variantClass = 'typography-body-small-bold';
        break;
      case 'body-small':
        Component = 'p';
        variantClass = 'typography-body-small';
        break;
      default:
        Component = 'p';
        variantClass = 'typography-body';
        break;
    }
  
    const combinedClassName = `typography ${variantClass} ${className || ''}`.trim();
  
    return (
      <Component
        className={combinedClassName}
        style={style}
      >
        {children}
      </Component>
    );
  };
  
export default Typography;